import { jsx as e, jsxs as d } from "react/jsx-runtime";
import { forwardRef as A, useState as y, useRef as I, useEffect as x, useCallback as F, useImperativeHandle as Z } from "react";
import M from "classnames";
import { Prism as D } from "react-syntax-highlighter";
import E from "react-markdown";
import G from "remark-gfm";
import U from "remark-math";
import O from "rehype-katex";
import j from "react-textarea-autosize";
import Q, { AxiosError as q } from "axios";
import { fetchEventSource as J } from "@microsoft/fetch-event-source";
const X = "_chatGptWrapper_1ohu2_1", Y = "_main_1ohu2_8", K = "_sendBox_1ohu2_14", L = {
  chatGptWrapper: X,
  main: Y,
  sendBox: K
}, ee = "_wrapper_zwmam_1", ne = "_robot_zwmam_1", oe = "_message_zwmam_4", te = "_headshot_zwmam_4", ae = "_content_zwmam_30", re = "_needLogin_zwmam_42", se = "_needUpgrade_zwmam_42", c = {
  wrapper: ee,
  robot: ne,
  message: oe,
  headshot: te,
  content: ae,
  needLogin: re,
  needUpgrade: se
}, ce = ({
  width: n = 41,
  height: t = 41,
  strokeWidth: a = 1.5,
  ...o
}) => /* @__PURE__ */ e(
  "svg",
  {
    width: n,
    height: t,
    viewBox: "0 0 41 41",
    strokeWidth: a,
    ...o,
    children: /* @__PURE__ */ e(
      "path",
      {
        d: "M37.5324 16.8707C37.9808 15.5241 38.1363 14.0974 37.9886 12.6859C37.8409 11.2744 37.3934 9.91076 36.676 8.68622C35.6126 6.83404 33.9882 5.3676 32.0373 4.4985C30.0864 3.62941 27.9098 3.40259 25.8215 3.85078C24.8796 2.7893 23.7219 1.94125 22.4257 1.36341C21.1295 0.785575 19.7249 0.491269 18.3058 0.500197C16.1708 0.495044 14.0893 1.16803 12.3614 2.42214C10.6335 3.67624 9.34853 5.44666 8.6917 7.47815C7.30085 7.76286 5.98686 8.3414 4.8377 9.17505C3.68854 10.0087 2.73073 11.0782 2.02839 12.312C0.956464 14.1591 0.498905 16.2988 0.721698 18.4228C0.944492 20.5467 1.83612 22.5449 3.268 24.1293C2.81966 25.4759 2.66413 26.9026 2.81182 28.3141C2.95951 29.7256 3.40701 31.0892 4.12437 32.3138C5.18791 34.1659 6.8123 35.6322 8.76321 36.5013C10.7141 37.3704 12.8907 37.5973 14.9789 37.1492C15.9208 38.2107 17.0786 39.0587 18.3747 39.6366C19.6709 40.2144 21.0755 40.5087 22.4946 40.4998C24.6307 40.5054 26.7133 39.8321 28.4418 38.5772C30.1704 37.3223 31.4556 35.5506 32.1119 33.5179C33.5027 33.2332 34.8167 32.6547 35.9659 31.821C37.115 30.9874 38.0728 29.9178 38.7752 28.684C39.8458 26.8371 40.3023 24.6979 40.0789 22.5748C39.8556 20.4517 38.9639 18.4544 37.5324 16.8707ZM22.4978 37.8849C20.7443 37.8874 19.0459 37.2733 17.6994 36.1501C17.7601 36.117 17.8666 36.0586 17.936 36.0161L25.9004 31.4156C26.1003 31.3019 26.2663 31.137 26.3813 30.9378C26.4964 30.7386 26.5563 30.5124 26.5549 30.2825V19.0542L29.9213 20.998C29.9389 21.0068 29.9541 21.0198 29.9656 21.0359C29.977 21.052 29.9842 21.0707 29.9867 21.0902V30.3889C29.9842 32.375 29.1946 34.2791 27.7909 35.6841C26.3872 37.0892 24.4838 37.8806 22.4978 37.8849ZM6.39227 31.0064C5.51397 29.4888 5.19742 27.7107 5.49804 25.9832C5.55718 26.0187 5.66048 26.0818 5.73461 26.1244L13.699 30.7248C13.8975 30.8408 14.1233 30.902 14.3532 30.902C14.583 30.902 14.8088 30.8408 15.0073 30.7248L24.731 25.1103V28.9979C24.7321 29.0177 24.7283 29.0376 24.7199 29.0556C24.7115 29.0736 24.6988 29.0893 24.6829 29.1012L16.6317 33.7497C14.9096 34.7416 12.8643 35.0097 10.9447 34.4954C9.02506 33.9811 7.38785 32.7263 6.39227 31.0064ZM4.29707 13.6194C5.17156 12.0998 6.55279 10.9364 8.19885 10.3327C8.19885 10.4013 8.19491 10.5228 8.19491 10.6071V19.808C8.19351 20.0378 8.25334 20.2638 8.36823 20.4629C8.48312 20.6619 8.64893 20.8267 8.84863 20.9404L18.5723 26.5542L15.206 28.4979C15.1894 28.5089 15.1703 28.5155 15.1505 28.5173C15.1307 28.5191 15.1107 28.516 15.0924 28.5082L7.04046 23.8557C5.32135 22.8601 4.06716 21.2235 3.55289 19.3046C3.03862 17.3858 3.30624 15.3413 4.29707 13.6194ZM31.955 20.0556L22.2312 14.4411L25.5976 12.4981C25.6142 12.4872 25.6333 12.4805 25.6531 12.4787C25.6729 12.4769 25.6928 12.4801 25.7111 12.4879L33.7631 17.1364C34.9967 17.849 36.0017 18.8982 36.6606 20.1613C37.3194 21.4244 37.6047 22.849 37.4832 24.2684C37.3617 25.6878 36.8382 27.0432 35.9743 28.1759C35.1103 29.3086 33.9415 30.1717 32.6047 30.6641C32.6047 30.5947 32.6047 30.4733 32.6047 30.3889V21.188C32.6066 20.9586 32.5474 20.7328 32.4332 20.5338C32.319 20.3348 32.154 20.1698 31.955 20.0556ZM35.3055 15.0128C35.2464 14.9765 35.1431 14.9142 35.069 14.8717L27.1045 10.2712C26.906 10.1554 26.6803 10.0943 26.4504 10.0943C26.2206 10.0943 25.9948 10.1554 25.7963 10.2712L16.0726 15.8858V11.9982C16.0715 11.9783 16.0753 11.9585 16.0837 11.9405C16.0921 11.9225 16.1048 11.9068 16.1207 11.8949L24.1719 7.25025C25.4053 6.53903 26.8158 6.19376 28.2383 6.25482C29.6608 6.31589 31.0364 6.78077 32.2044 7.59508C33.3723 8.40939 34.2842 9.53945 34.8334 10.8531C35.3826 12.1667 35.5464 13.6095 35.3055 15.0128ZM14.2424 21.9419L10.8752 19.9981C10.8576 19.9893 10.8423 19.9763 10.8309 19.9602C10.8195 19.9441 10.8122 19.9254 10.8098 19.9058V10.6071C10.8107 9.18295 11.2173 7.78848 11.9819 6.58696C12.7466 5.38544 13.8377 4.42659 15.1275 3.82264C16.4173 3.21869 17.8524 2.99464 19.2649 3.1767C20.6775 3.35876 22.0089 3.93941 23.1034 4.85067C23.0427 4.88379 22.937 4.94215 22.8668 4.98473L14.9024 9.58517C14.7025 9.69878 14.5366 9.86356 14.4215 10.0626C14.3065 10.2616 14.2466 10.4877 14.2479 10.7175L14.2424 21.9419ZM16.071 17.9991L20.4018 15.4978L24.7325 17.9975V22.9985L20.4018 25.4983L16.071 22.9985V17.9991Z",
        fill: "white"
      }
    )
  }
);
const ie = {
  'code[class*="language-"]': {
    color: "black",
    background: "none",
    textShadow: "0 1px white",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: "1em",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none"
  },
  'pre[class*="language-"]': {
    color: "black",
    background: "#f5f2f0",
    textShadow: "0 1px white",
    fontFamily: "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
    fontSize: "1em",
    textAlign: "left",
    whiteSpace: "pre",
    wordSpacing: "normal",
    wordBreak: "normal",
    wordWrap: "normal",
    lineHeight: "1.5",
    MozTabSize: "4",
    OTabSize: "4",
    tabSize: "4",
    WebkitHyphens: "none",
    MozHyphens: "none",
    msHyphens: "none",
    hyphens: "none",
    padding: "1em",
    margin: ".5em 0",
    overflow: "auto"
  },
  'pre[class*="language-"]::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"] ::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"]::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"] ::-moz-selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"]::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'pre[class*="language-"] ::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"]::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  'code[class*="language-"] ::selection': {
    textShadow: "none",
    background: "#b3d4fc"
  },
  ':not(pre) > code[class*="language-"]': {
    background: "#f5f2f0",
    padding: ".1em",
    borderRadius: ".3em",
    whiteSpace: "normal"
  },
  comment: {
    color: "slategray"
  },
  prolog: {
    color: "slategray"
  },
  doctype: {
    color: "slategray"
  },
  cdata: {
    color: "slategray"
  },
  punctuation: {
    color: "#999"
  },
  namespace: {
    Opacity: ".7"
  },
  property: {
    color: "#905"
  },
  tag: {
    color: "#905"
  },
  boolean: {
    color: "#905"
  },
  number: {
    color: "#905"
  },
  constant: {
    color: "#905"
  },
  symbol: {
    color: "#905"
  },
  deleted: {
    color: "#905"
  },
  selector: {
    color: "#690"
  },
  "attr-name": {
    color: "#690"
  },
  string: {
    color: "#690"
  },
  char: {
    color: "#690"
  },
  builtin: {
    color: "#690"
  },
  inserted: {
    color: "#690"
  },
  operator: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  entity: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)",
    cursor: "help"
  },
  url: {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  ".language-css .token.string": {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  ".style .token.string": {
    color: "#9a6e3a",
    background: "hsla(0, 0%, 100%, .5)"
  },
  atrule: {
    color: "#07a"
  },
  "attr-value": {
    color: "#07a"
  },
  keyword: {
    color: "#07a"
  },
  function: {
    color: "#DD4A68"
  },
  "class-name": {
    color: "#DD4A68"
  },
  regex: {
    color: "#e90"
  },
  important: {
    color: "#e90",
    fontWeight: "bold"
  },
  variable: {
    color: "#e90"
  },
  bold: {
    fontWeight: "bold"
  },
  italic: {
    fontStyle: "italic"
  }
}, le = ({
  node: n,
  inline: t,
  className: a,
  children: o,
  ...r
}) => {
  const l = /language-(\w+)/.exec(a || "");
  return t ? /* @__PURE__ */ e("code", { className: a, ...r, children: o }) : /* @__PURE__ */ e(
    D,
    {
      children: String(o).replace(/\n$/, ""),
      style: ie,
      language: l == null ? void 0 : l[1],
      PreTag: "div",
      ...r
    }
  );
}, de = ({ content: n }) => /* @__PURE__ */ e(
  E,
  {
    children: n,
    remarkPlugins: [G, U],
    rehypePlugins: [O],
    components: { code: le }
  }
), ue = "_spinner_1eqa8_1", me = "_bounce1_1eqa8_15", he = "_bounce2_1eqa8_19", S = {
  spinner: ue,
  "sk-bouncedelay": "_sk-bouncedelay_1eqa8_1",
  bounce1: me,
  bounce2: he
}, pe = () => /* @__PURE__ */ d("div", { className: S.spinner, children: [
  /* @__PURE__ */ e("div", { className: S.bounce1 }),
  /* @__PURE__ */ e("div", { className: S.bounce2 }),
  /* @__PURE__ */ e("div", {})
] }), T = ({
  who: n,
  headshot: t,
  content: a = "",
  id: o,
  code: r = 0,
  onLogin: l,
  onQuotaUsedUp: f
}) => {
  const w = () => t ? n === "user" ? /* @__PURE__ */ e("img", { className: c.headshot, src: t, alt: "" }) : /* @__PURE__ */ e("div", { className: c.headshot, children: /* @__PURE__ */ e(ce, { width: 32, height: 32 }) }) : null, b = () => {
    if (a.trim() === "")
      return /* @__PURE__ */ e("div", { className: c.content, children: /* @__PURE__ */ e(pe, {}) });
    if (n === "robot") {
      if (r === 401)
        return /* @__PURE__ */ e("div", { className: c.content, children: /* @__PURE__ */ d("div", { className: c.needLogin, children: [
          /* @__PURE__ */ e("span", { children: "需要登录后才能使用" }),
          /* @__PURE__ */ e("span", { onClick: l, children: "立即登录" })
        ] }) });
      if (r === 10)
        return /* @__PURE__ */ e("div", { className: c.content, children: /* @__PURE__ */ e("span", { children: "提问请勿包含敏感词" }) });
      if (r === 20)
        return /* @__PURE__ */ e("div", { className: c.content, children: /* @__PURE__ */ e("span", { children: "请输入有效的问题" }) });
      if (r === 30)
        return /* @__PURE__ */ e("div", { className: c.content, children: /* @__PURE__ */ d("div", { className: c.needUpgrade, children: [
          /* @__PURE__ */ e("span", { children: "额度已用完。升级成为VIP 用户，解锁 20+ Python全系列课程，每日100次 AI 答疑额度。" }),
          /* @__PURE__ */ e("span", { onClick: f, children: "立即升级" })
        ] }) });
    }
    return /* @__PURE__ */ e("div", { className: c.content, children: /* @__PURE__ */ e(de, { content: a }) });
  };
  return /* @__PURE__ */ e("div", { className: M(c.wrapper, c[n]), id: `message-${o}`, children: /* @__PURE__ */ d("div", { className: M(c.message), children: [
    w(),
    b()
  ] }) });
}, ge = "_wrapper_1i9it_1", Ce = "_container_1i9it_4", _e = "_quota_1i9it_10", fe = "_number_1i9it_16", be = "_main_1i9it_19", we = "_textarea_1i9it_23", ke = "_sendBtn_1i9it_35", m = {
  wrapper: ge,
  container: Ce,
  quota: _e,
  number: fe,
  main: be,
  textarea: we,
  sendBtn: ke
}, ve = ({
  strokeWidth: n = 2,
  width: t = "1em",
  height: a = "1em",
  stroke: o = "white",
  fill: r = "#575BFD",
  ...l
}) => /* @__PURE__ */ e("svg", { width: "21", height: "23", viewBox: "0 0 21 23", fill: "none", ...l, children: /* @__PURE__ */ e(
  "path",
  {
    d: "M20.4624 12.0746C21.1554 11.7009 21.1574 11.0964 20.4624 10.7218L1.64 0.572859C0.947 0.199109 0.384625 0.628109 0.38325 1.51617L0.375 8.84167L15.6196 11.3978L0.375 13.9539L0.38325 21.2802C0.384625 22.1748 0.944937 22.5981 1.64 22.2235L20.4624 12.0746Z",
    fill: r
  }
) }), ye = "_skFadingCircle_1havp_9", Ne = "_skCircle_1havp_15", i = {
  skFadingCircle: ye,
  skCircle: Ne,
  "sk-circleFadeDelay": "_sk-circleFadeDelay_1havp_1"
}, xe = () => /* @__PURE__ */ d("div", { className: i.skFadingCircle, children: [
  /* @__PURE__ */ e("div", { className: i.skCircle }),
  /* @__PURE__ */ e("div", { className: i.skCircle }),
  /* @__PURE__ */ e("div", { className: i.skCircle }),
  /* @__PURE__ */ e("div", { className: i.skCircle }),
  /* @__PURE__ */ e("div", { className: i.skCircle }),
  /* @__PURE__ */ e("div", { className: i.skCircle }),
  /* @__PURE__ */ e("div", { className: i.skCircle }),
  /* @__PURE__ */ e("div", { className: i.skCircle }),
  /* @__PURE__ */ e("div", { className: i.skCircle }),
  /* @__PURE__ */ e("div", { className: i.skCircle }),
  /* @__PURE__ */ e("div", { className: i.skCircle }),
  /* @__PURE__ */ e("div", { className: i.skCircle })
] }), Le = ({
  className: n,
  onSend: t,
  loading: a,
  quota: o,
  ...r
}) => {
  const l = () => a ? /* @__PURE__ */ e("div", { className: m.sendBtn, children: /* @__PURE__ */ e(xe, {}) }) : /* @__PURE__ */ e("div", { className: m.sendBtn, onClick: t, children: /* @__PURE__ */ e(ve, {}) });
  return /* @__PURE__ */ e("div", { className: M(m.wrapper, n), children: /* @__PURE__ */ d("div", { className: m.container, children: [
    typeof o == "number" && /* @__PURE__ */ d("div", { className: m.quota, children: [
      "当天剩余次数：",
      /* @__PURE__ */ e("span", { className: m.number, children: o }),
      " 次"
    ] }),
    /* @__PURE__ */ d("div", { className: m.main, children: [
      /* @__PURE__ */ e(
        j,
        {
          placeholder: "你也可以在此输入你想咨询的问题哟~",
          className: m.textarea,
          minRows: 1,
          maxRows: 12,
          ...r
        }
      ),
      l()
    ] })
  ] }) });
}, Se = "_container_1l7xd_1", Me = {
  container: Se
}, ze = () => /* @__PURE__ */ d("div", { className: Me.container, children: [
  /* @__PURE__ */ e("svg", { viewBox: "0 0 1024 1024", version: "1.1", xmlns: "http://www.w3.org/2000/svg", "p-id": "2411", width: "200", height: "200", children: /* @__PURE__ */ e("path", { d: "M896 685.408V192a32 32 0 0 0-32-32H160c-17.632 0-32 14.336-32 32v668.064l145.984-126.944a64.192 64.192 0 0 1 41.984-15.712H864a32 32 0 0 0 32-32zM864 96c52.928 0 96 43.072 96 96v493.408c0 52.928-43.072 96-96 96H315.968l-145.952 126.944a63.552 63.552 0 0 1-46.464 15.552A64.096 64.096 0 0 1 64 860.064V192c0-52.928 43.072-96 96-96h704z m-204.576 252.576a32 32 0 1 1 0 64H333.696a32 32 0 0 1 0-64h325.76z m-131.776 148.576a32 32 0 1 1 0 64h-193.92a32 32 0 0 1 0-64h193.92z", fill: "#e5e5e5", "p-id": "2412" }) }),
  /* @__PURE__ */ e("div", { style: { marginTop: 10 }, children: "请输入问题" })
] }), h = Q.create({
  baseURL: "//edu.py2fun.com/",
  withCredentials: !0
});
h.interceptors.response.use((n) => {
  const { status: t } = n;
  if (t < 200 && t >= 300) {
    const { msg: a } = n.data, o = new q();
    throw o.code = t.toString(), o.response = n, o.config = n.config, o.request = n.request, o.message = a, o;
  }
  return n;
});
h.interceptors.response.use(
  async (n) => {
    const { code: t, data: a, msg: o } = n.data;
    if (t === 0)
      return a;
    const r = new q();
    throw r.code = t.toString(), r.response = n, r.config = n.config, r.request = n.request, r.message = o, n.status === 401 && (r.message = o ?? "请先登录"), r;
  },
  (n) => {
    if (n.response)
      switch (n.response.status) {
        case 401:
          return window.dispatchEvent(new Event("need-login")), Promise.reject("需要登录");
      }
    return Promise.reject(n);
  }
);
const Be = () => h.get("/api/chat/tbot/left_num"), Oe = async (n) => (await h.get("/api/chat/rooms", {
  params: {
    course_no: n
  }
}) || []).map((a) => ({
  roomKey: a.room_key,
  roomType: a.roomType,
  name: a.name,
  userId: a.user_id,
  courseNo: a.course_no
})), Te = async (n, t, a) => {
  const o = await h.get(`/api/chat/room/${n}/msgs`, {
    params: {
      page: t,
      page_size: a
    }
  });
  return ((o == null ? void 0 : o.results) || []).map((r) => ({
    id: r.id,
    senderType: r.sender_type,
    content: r.content,
    userId: r.user_id
  })).reverse();
}, P = async (n, t, a) => {
  const o = await h.post(
    `/api/chat/room/${n}/send_msg`,
    {
      content: t,
      sender_type: a
    }
  );
  return {
    id: o.id,
    senderType: o.sender_type,
    content: o.content,
    userId: o.user_id
  };
}, Pe = async (n) => (await h.post("/api/chat/quiz/prompt", {
  course_no: n.courseNo,
  question_id: n.questionId,
  mode: n.mode
})).prompt, qe = async (n) => (await h.post("/api/chat/code/prompt", {
  language: n.language,
  source_code: n.sourceCode,
  mode: n.mode,
  stdin: n.stdin,
  stdout: n.stdout,
  stderr: n.stderr
})).prompt, Re = (n, { onmessage: t, onclose: a }) => {
  const o = new AbortController();
  return J("https://edu.py2fun.com/api/chat/tbot/reply", {
    method: "POST",
    body: JSON.stringify({ prompt: n }),
    headers: {
      "Content-Type": "application/json"
    },
    signal: o.signal,
    onerror: (r) => {
      o.abort();
    },
    onmessage: t,
    onclose: a
  });
}, He = ({ userHeadshot: n, roomKey: t, showHistory: a, onLogin: o, onQuotaUsedUp: r }, l) => {
  const [f, w] = y(""), [b, _] = y([]), [R, z] = y(0), [N, p] = y(!1), B = I(null);
  x(() => {
    if (!(!t || !a))
      return p(!0), Te(t, 1, 100).then((s) => {
        _(s), p(!1);
      }), () => _([]);
  }, [t, a]), x(() => {
    const s = B.current;
    s && s.scrollTo({
      top: s.scrollHeight,
      behavior: "smooth"
    });
  }, [b]), x(() => {
    Be().then(({ left_num: s }) => z(s));
  }, []);
  const k = F((s) => {
    P(t, s, "user").then((g) => {
      _((C) => [...C, g]);
      const v = {
        id: 0,
        senderType: "tbot",
        content: "",
        userId: 0
      };
      _((C) => [...C, v]), Re(s, {
        onmessage: (C) => {
          const u = JSON.parse(C.data);
          v.content = u.content, v.code = u.code, _(($) => [...$]), u.left_num && z(u.left_num);
        },
        onclose: () => {
          P(t, v.content, "tbot").then((C) => {
            _((u) => (u[u.length - 1].id = C.id, [...u]));
          }).finally(() => {
            p(!1);
          });
        }
      });
    }).finally(() => {
      p(!1);
    });
  }, []);
  Z(
    l,
    () => ({
      execCodePrompt: async (s) => {
        if (N)
          return;
        p(!0);
        const g = await qe(s);
        k(g);
      },
      execQuizPrompt: async (s) => {
        if (N)
          return;
        p(!0);
        const g = await Pe(s);
        k(g);
      }
    }),
    [t, k]
  );
  const H = (s) => {
    const g = s.target.value;
    w(g);
  }, V = () => {
    f.trim() && (p(!0), k(f), w(""));
  }, W = (s) => s.senderType === "user" ? /* @__PURE__ */ e(
    T,
    {
      who: "user",
      content: s.content,
      headshot: n,
      id: s.id
    },
    s.id
  ) : s.senderType === "tbot" ? /* @__PURE__ */ e(
    T,
    {
      id: s.id,
      who: "robot",
      content: s.content,
      headshot: n,
      code: s.code,
      onLogin: o,
      onQuotaUsedUp: r
    },
    s.id
  ) : null;
  return /* @__PURE__ */ d("div", { className: L.chatGptWrapper, children: [
    /* @__PURE__ */ d("div", { ref: B, className: L.main, children: [
      !b.length && /* @__PURE__ */ e(ze, {}),
      b.map(W)
    ] }),
    /* @__PURE__ */ e(
      Le,
      {
        className: L.sendBox,
        value: f,
        onChange: H,
        onSend: V,
        quota: R,
        loading: N
      }
    )
  ] });
}, je = A(He);
export {
  je as default,
  Oe as showChatRooms
};
//# sourceMappingURL=index.js.map
